import PropTypes from "prop-types";
import React, { useEffect } from "react";
import StyledContainer from "../../../../partials/StyledContainer";
import { GameStatus, QuestionStatus } from "../../constants";
import ElementLesson from "../../ElementLesson/ElementLesson";
import { useGameStatusContext } from "../../providers/gameStatusProvider";
import { useMissionElementsContext } from "../../providers/missionElementsProvider";
import { useProgressContext } from "../../providers/progressProvider";
import styles from "./Results.module.scss";
import styled from "styled-components";
import Button from '../../../../partials/Button'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function Results({ options, pages, elements, onComplete, goToNext, data }) {
  const [isSuccess, setIsSuccess] = React.useState(true);
  const [lessons, setLessons] = React.useState();
  const [lessonsCompleted, setLessonsCompleted] = React.useState();
  const [pageOption, setPageOption] = React.useState();
  const [selectedElement, setSelectedElement] = React.useState();
  const [showLesson, setShowLesson] = React.useState(false);
  const [gameStatus, setGameStatus] = useGameStatusContext();
  const [stateElements, dispatch] = useMissionElementsContext();
  const [progress, setProgress] = useProgressContext();
  const [showResults, setShowResults] = React.useState(false);
  const [selectedNum, setSelectedNum] = React.useState(-1);

  const onActionClick = (action, retryelements) => {
    if (action === "restart") {
      handleRestart();
      let firstRoundStatus = {
        ...gameStatus,
        round: "firstRound",
        score: 0,
        status: GameStatus.STOPPED,
      };

      let progress = {
        available: 0,
        dispatched: 0,
        total: 0,
      };

      let newDispatch = {
        type: "SET_ELEMENTS",
        payload: {
          elements: retryelements,
          options,
          gameStatus: firstRoundStatus,
        },
      };

      setGameStatus(firstRoundStatus);
      dispatch(newDispatch);
      setProgress(progress);
      setShowResults(false);
    }else if (action === "retry" && retryelements) {
      let secondRoundStatus = {
        ...gameStatus,
        round: "secondRound",
        score: 0,
        status: GameStatus.STOPPED,
      };

      let progress = {
        available: 0,
        dispatched: 0,
        total: 0,
      };

      let newDispatch = {
        type: "SET_ELEMENTS",
        payload: {
          elements: retryelements,
          options,
          gameStatus: secondRoundStatus,
        },
      };

      setGameStatus(secondRoundStatus);
      dispatch(newDispatch);
      setProgress(progress);
      setShowResults(false);
    }
  };

  const handleElementClick = (i) => {

    setSelectedNum(i)

    // if (isSuccess === false && e.isCompleted === false) {
    //   setSelectedElement(e);
    //   setShowLesson(true);
    // }
    
  };

  const handleLessonClose = () => {
    setShowLesson(false);
  };

  const handleOnComplete = (e) => {
    setLessons(
      lessons.map((l) => {
        if (l.caption === e.caption) {
          return {
            ...l,
            isCompleted: true,
          };
        }
        return l;
      })
    );
  };

  const handleRestart = () => {
    setLessons(
      lessons.map((l) => {
          return {
            ...l,
            isCompleted: false,
          };
      })
    );
  };

  useEffect(() => {
    let checkIfSuccess = true;    
    setLessons(
      elements.map((e) => {        
        let calculateScore = 0;
        let totalScore = 0;
        e.questions[gameStatus.round].forEach((q) => {
          totalScore += q.value;
          switch (q.status) {
            case QuestionStatus.ANSWERED_RIGHT:
              calculateScore += q.value;
              break;
            case QuestionStatus.ANSWERED_WRONG:
              //calculateScore -= q.value;
              calculateScore -= 0;
              break;
            case QuestionStatus.TIMED_OUT:
              //calculateScore -= options.defaultTimedOutQuestionScoreValue;
              calculateScore -= 0;
              break;
            default:
              break;
          }
        });
        console.log("totalScore" , totalScore);
        if (calculateScore < options.minimumElementSuccessScore) {
          checkIfSuccess = false;
        }

        console.log("calculateScore" , calculateScore);
        console.log("options.minimumElementSuccessScore" , options.minimumElementSuccessScore);

        return {
          ...e,
          isSuccess: calculateScore >= options.minimumElementSuccessScore,
          isCompleted: false,
          totalScore: totalScore,
          score: calculateScore,
        };
      })
    );
    setIsSuccess(checkIfSuccess);
    console.log(gameStatus)
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [elements]);

  useEffect(() => {
    if (typeof isSuccess !== "undefined") {
      const options =
        pages[gameStatus.round][isSuccess === true ? "success" : "failure"];
      setPageOption(options);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (!lessons) {
      return;
    }
    const notcompletedElem = lessons.filter(
      (l) => l.isSuccess === false && l.isCompleted === false
    );
    if (notcompletedElem.length === 0) {
      setLessonsCompleted(true);
    }
  }, [lessons]);

  if (typeof isSuccess === "undefined" || !pageOption) {
    return null;
  }

  function setMarkup(isSuccess) {
    if (isSuccess === true) {
      if (onComplete) {
        onComplete();
      }
    }
    return { __html: pageOption.page };
  }

  if (!elements) {
    return null;
  }

  const mapLessons = (e, i) => {
    let itemNumber = i;
    return (
      <div
        className={styles.resultElement}
        key={e.caption}
        onClick={() => {
          handleElementClick(i);
        }}
      >
      
        <div className={styles.resultElementsCaption}>
          <Icon>
            <img src={e.image} width={30} alt={e.alt} />
          </Icon>
          {e.caption}
        </div>
        <ScoreBox completed={e.isSuccess === true || e.isCompleted === true}>      
          {/* {('0' + e.score).slice(-2)}   */}
          {e.score + " out of " + e.totalScore}   
        </ScoreBox>
        {selectedNum === i && e.isSuccess === false && <BlueNote >{e.review}</BlueNote>}
      </div>
    );
  };

  if (gameStatus.status !== GameStatus.FINISHED) return null;

  return (
    <>
      <ElementLesson
        element={selectedElement}
        show={showLesson}
        onClose={handleLessonClose}
        onComplete={() => {
          handleOnComplete(selectedElement);
        }}
      />
      <div className={styles.resultContainer}>
        <div className={styles.resultsText}>
          <StyledContainer variant="light_blue">
            <ScoreText>
              {`You scored `}
              <span className={"results_text_score"}>
                {gameStatus.score}/{gameStatus.totalScore}
              </span>
              .
            </ScoreText>
            <div
              className={styles.results_paragraph}
              dangerouslySetInnerHTML={setMarkup(isSuccess)}
            ></div>
            <div className={"results_actions"}>             
              {gameStatus.round === "firstRound" &&
                isSuccess === false && (
                  <Button text={pageOption.retakeButtonCaption} onClick={() => onActionClick("retry", lessons.filter((e) => e.isSuccess === false))}/>
                )}  
              {lessonsCompleted === true &&
                gameStatus.round === "firstRound" &&
                isSuccess === false && (
                  <Button text={pageOption.retakeButtonCaption} onClick={() => onActionClick("retry", lessons.filter((e) => e.isSuccess === false))}/>
                )}             
              {pageOption.showRestartGameButton === true &&
                (lessonsCompleted === true ||
                  gameStatus.round === "secondRound" ||
                  isSuccess) && (
                    <div>
                  <Button text={pageOption.restartButtonCaption} onClick={() => onActionClick("restart", lessons)}/>
                  <Button text="Next" onClick={goToNext}/>
                </div>
                )}
                {/* <Button text="Next" onClick={goToNext}/> */}
            </div>
          </StyledContainer>
        </div>
        {/* {gameStatus.round === "firstRound" && ( */}
        <div className={styles.resultsElements}>
          <StyledContainer variant="light_blue">
              {!isSuccess && <Instructions>{data.instructionsresults || "Click highlighted scores to see more information."}</Instructions>}
              <div className={styles.resultsSumary}>
                {lessons && lessons.map(mapLessons)}
              </div>
          </StyledContainer>
        </div>)
        {/* } */}
      </div>
    </>
  );
}

const ScoreText = styled.div`
  font-family: 'Rajdhani';
  font-size: 20px;
  font-weight: bold;
  width: 100%;
`;

const ContentBox = styled.div`
  width: 150px; 
`;

const Instructions = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #ABA4A7;
  line-height: 60px;  
`;

const Icon = styled.div`
  filter: invert(68%) sepia(10%) saturate(1205%) hue-rotate(160deg) brightness(90%) contrast(83%); 
`;

const Label = styled.div`
  display: inline-block;
  width: 90px;
`;

const ScoreBox = styled.div`
  color: ${({ completed }) => (completed ? `white` : `#FF9D09`)};
  height: auto;
  text-align: center;
  background-color: #0E1118;
  border: solid 1px #78A1BB;
  padding: 5px;
  font-family: 'Rajdhani';
  font-size: 18px;
  font-weight: bold;
  float: right;
  line-height: 25px;
  width: 103px;
  cursor:  ${({ completed }) => (completed ? `default` : `pointer`)};
`;

const BlueNote = styled.div`
  color: white;
  min-width: 160px;
  text-align: left;
  background-color: #78A1BB;
  padding: 20px;
  font-family: 'Poppins';
  font-size: 14px !important;
  position: absolute;
  font-weight: normal;
  left: 105%;

  &::before{
    content: '';
    border-left: solid white 2px;
    border-bottom: solid white 2px;
    width: 65px; 
    height: 10px; 
    position: absolute;
    top: 38px;
    left: -67px;
  }
`;

export default Results;

Results.propTypes = {
  elements: PropTypes.array,
  gameStatus: PropTypes.object.isRequired,
  onActionClick: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  pages: PropTypes.object.isRequired,
};

Results.defaultProps = {
  onActionClick: () => {},
};
